export type AnyRootStore = Record<string, any>;

export class ConnectRootStore<T = AnyRootStore> {
    public root: T;

    constructor(root: T) {
        this.root = root;
    }
}
